module.exports = __webpack_public_path__ + "common/loading-741043c2de9cbe7ed4455ca18e48ea9c.gif";